/**
 * Supabase Browser Client
 *
 * Client-side Supabase client for use in React components and client-side code.
 * Uses localStorage for session persistence and handles authentication state.
 */

import { createBrowserClient } from '@supabase/ssr';
import type { Database } from '../db/types';

export function createClient() {
  return createBrowserClient<Database>(
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!
  );
}

// Export a singleton instance for convenience
export const supabase = createClient();